import { normalizeTimes } from '@uplift/api';


export const useNormalizeTimes = () => {
  return {
    normalizeTimes: normalizeTimes,
  };
};
